/**
 * These styles override the theme so our Mui inputs match the Stripe UI
 */
export const StripeInputStyle = {
    fontStyle: "normal",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontColor: "rgb(48, 49, 61)",
};
